import { render } from "./PainelDispositivoView.vue?vue&type=template&id=5150aece&scoped=true"
import script from "./PainelDispositivoView.vue?vue&type=script&lang=js"
export * from "./PainelDispositivoView.vue?vue&type=script&lang=js"

import "./PainelDispositivoView.vue?vue&type=style&index=0&id=5150aece&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5150aece"]])

export default __exports__